import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { Connection } from '@3d-scene/model3d/connection';
import { ArticleVO } from '../../../model/vo/article.vo';
import { PropertyVO } from '@project/components/article/model/vo/property.vo';
import { ConnectionAreaVO } from '@shared/vo/meta-element.vo';
import { ArticleUtils } from '../../../util/article-utils';
import { ArticleUsageUtils } from '../../../util/article-usage-utils';
import { Busbar } from './replace-busbar-data';
import { ReplaceBusbarUtils } from './replace-busbar-utils';
import { InsertArticleHelper } from '../../insert-article.helper';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

export class ReplaceBusbarDataBuilder {

  public static buildBusbar(source: ArticleContainer, insertArticleHelper: InsertArticleHelper): Busbar {
    const busbar: Busbar = new Busbar();
    busbar.originalUsageId = source.articleGUID;
    busbar.articleId = source.articleUsage.articleId;
    busbar.articleVersion = source.articleUsage.articleVersion;
    busbar.backwardAcceptingIds = ArticleUsageUtils.getBackwardConnectedConnectionUsageIds(source.articleUsage);
    const givingConnections: Connection[] = this.extractGivingConnections(source);
    busbar.featureProperties = this.buildFeaturePropertyList(givingConnections[0], source.article);
    busbar.additionalLengthStart = ReplaceBusbarUtils.getBusbarStartOffset(source);
    busbar.additionalLengthEnd = ReplaceBusbarUtils.getBusbarEndOffset(source);
    busbar.connectedUsageIds = ArticleUsageUtils.getForwardConnectedConnectionUsageIds(source.articleUsage);
    busbar.insertArticleHelper = insertArticleHelper;
    busbar.endOverhangChildrenUsageIds = ReplaceBusbarUtils.getEndOverhangChildrenUsageIds(busbar);
    return busbar;
  }

  private static buildFeaturePropertyList(sourceConnection: Connection, article: ArticleVO): PropertyVO[] {
    if (!sourceConnection || !(sourceConnection.metaElementVO instanceof ConnectionAreaVO) || !article) {
      return [];
    }
    return ConnectionInfoUtils.createFeaturePropertyList(sourceConnection.metaElementVO, article);
  }

  private static extractGivingConnections(articleContainer: ArticleContainer): Connection[] {
    const givingConnections: Connection[] = [];
    const givingConnectionElements: ConnectionAreaVO[] = ArticleUtils.getConnectionElements(articleContainer.article,
      ConnectionAreaVO.SIDE_GIVING);
    for (const givingArea of givingConnectionElements) {
      const connection: Connection = articleContainer.findFirstConnectionByName(givingArea.name);
      if (connection) {
        givingConnections.push(connection);
      }
    }
    return ConnectionInfoUtils.sortConnections(givingConnections, true);
  }

}
